import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Mobon(){
    const { pathname } = useLocation();

    useEffect(() => {
        window.callDM = window.callDM || function () {
            (window.callDM.q = window.callDM.q || []).push(arguments);
        };
    }, []);

    useEffect(() => {
        if (window.callDM) {
            window.callDM();
        }
    }, [pathname]);

    return null;
}